import { Injectable } from "@angular/core";

const localStorageKey = "USER";

@Injectable({
  providedIn: "root",
})
export class UserService {
  constructor() {}

  getUserData() {
    if (typeof window === "undefined") return;
    const userData = localStorage.getItem(localStorageKey);
    return userData ? JSON.parse(userData) : null;
    // bearerToken
  }

  isMainAccount(){
    const userData = this.getUserData();
    return !userData?.isChildUserAccount;
  }

  clearUserData() {
    localStorage.removeItem(localStorageKey);
    localStorage.removeItem("token");
  }

  updateUserData(data: any) {
    if (typeof window === "undefined") return;
    const savedData = this.getUserData();
    const mergedData = { ...savedData, ...data };

    localStorage.setItem(localStorageKey, JSON.stringify(mergedData)); //to string
    if (data?.bearerToken) localStorage.setItem("token", data?.bearerToken); //to string
  }

  isUserLoggedIn() {
    return this.getUserData();
  }

  getUserDevicePrint() {
    return "12121212";
  }

  getUserBearerToken() {
    return this.isUserLoggedIn() ? localStorage.getItem("token") : "";
  }
}
